module.exports = __webpack_public_path__ + "static/baby-eda1a7e21f64e5bdbc7fe11b057072a2.svg";